module.exports = __webpack_public_path__ + "f5dfcac6ca2c282beca0e6ceb63a53de.MP3";